/**
 * Cookieconsent config
 * https://www.osano.com/cookieconsent/documentation/javascript-api/
 */
window.addEventListener("load", function(){
    let cookiesconsentPopup;
    window.cookieconsent.initialise({
        revokable: true,
        type: "opt-in",
        content: {
            "message": "Ce site utilise des cookies essentiels à son fonctionnement.<br>Et souhaite utiliser des cookies de sites partenaires à des fins de suivi de fréquentation.<br>Pour en apprendre plus au sujet des cookies, consultez le site de la",
            "dismiss": "Fermer",
            "allow": "Accepter",
            "deny": "Refuser les cookies non essentiels",
            "link": "CNIL",
            "href": "https://www.cnil.fr/fr/les-conseils-de-la-cnil-pour-maitriser-votre-navigateur",
        },
        onInitialise: function(status) {
            if (this.hasConsented()) {
                loadCookiesRelatedScripts();
            }
        },
        onStatusChange: function(status) {
            if (this.hasConsented()) {
                loadCookiesRelatedScripts();
            };
        },
    }, function (popup) {
        cookiesconsentPopup = popup;
    }, function (err) {
        console.log(err);
    });

    document.getElementById('cookies-settings').onclick = function (e) {
        e.preventDefault();
        cookiesconsentPopup.revokeChoice();
    }
});

function loadCookiesRelatedScripts() {
    $.getScript('https://www.google-analytics.com/analytics.js');
}
